

export const FETCH_DIRECTORS_REQUEST = 'FETCH_DIRECTORS_REQUEST';
export const FETCH_DIRECTORS_SUCCESS = 'FETCH_DIRECTORS_SUCCESS';
export const FETCH_DIRECTORS_FAILURE = 'FETCH_DIRECTORS_FAILURE';

export const fetchDirectorsRequest = () => {
  return{
    type: FETCH_DIRECTORS_REQUEST
  };
};

export const fetchDirectorsSuccess = directors => {
  return {
    type: FETCH_DIRECTORS_SUCCESS,
    directors
  };
};
export const fetchDirectorsFailure = error => {
  return {
    type: FETCH_DIRECTORS_FAILURE,
    error
  };
};

export const fetchDirectors = () => {
  return dispatch => {
    dispatch(fetchDirectorsRequest());

    return fetch(`${apiBase}/wp/v2/directors?per_page=99`)
      .then(response => response.json())
      .then(json => dispatch(fetchDirectorsSuccess(json)));
  };
};
